import React, { useState } from 'react';
import Holdings13FDashboard from './Holdings13FDashboard';

const TABS = [
  { id: '13f', label: '13F Holdings' },
];

export default function App() {
  const [activeTab, setActiveTab] = useState('13f');

  return (
    <div style={{ minHeight: '100vh', background: '#0d1117', fontFamily: 'monospace', color: '#e6edf3' }}>
      {/* Header */}
      <div style={{ background: '#161b22', borderBottom: '1px solid #21262d', padding: '12px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#e6edf3', letterSpacing: '2px' }}>ODYSSEY</div>
          <div style={{ fontSize: 10, color: '#8b949e', letterSpacing: '1px', marginTop: 2 }}>PORTFOLIO ANALYTICS</div>
        </div>
        <div style={{ fontSize: 10, color: '#8b949e' }}>SEC Form 13F · Q4 2011 – Q4 2025</div>
      </div>

      {/* Tab Bar */}
      <div style={{ display: 'flex', borderBottom: '1px solid #21262d', padding: '0 24px', background: '#0d1117' }}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: '10px 20px',
              fontSize: 11,
              fontWeight: 600,
              border: 'none',
              borderBottom: activeTab === tab.id ? '2px solid #58a6ff' : '2px solid transparent',
              background: 'transparent',
              color: activeTab === tab.id ? '#58a6ff' : '#8b949e',
              cursor: 'pointer',
              letterSpacing: '0.5px',
              fontFamily: 'monospace',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      {activeTab === '13f' && <Holdings13FDashboard />}
    </div>
  );
}
